// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__165CC","clinicsSelect":"TableHeading_clinicsSelect__11ND5"};